class Exception {
  costructor() {
    this.prototype.test = function (msg) {
      this.uploadExecptionMsg(msg);
    };

    this.prototype.hasNotAction = function (actionName) {
      this.contentTypeuploadExecptionMsg('控制器中没有该方法' + actionName);
    };

    /**
     * 网络请求成功上报
     * @param xhr
     * @param requestInfo
     */
    this.prototype.requestSuccessLog = function (xhr, requestInfo) {
      this.uploadExceptionResponse({
        requestUrl: requestInfo.url,
        type: requestInfo.type,
        requestContentType: requestInfo.contentType,
        acceptContentType: requestInfo.dataType,
        param: requestInfo.data,
        crossDomain: requestInfo.crossDomain,
        responseHeaders: xhr.getAllResponseHeaders ? xhr.getAllResponseHeaders() : '',
        responseText: xhr.responseText,
        responseStatus: xhr.status
      });
    };
    /**
     * 网络请求错误处理
     * model未做错误处理（没有传error回调）的默认处理
     */
    this.prototype.requestException = function (xhr, requestInfo) {
      this.uploadExceptionResponse({
        requestUrl: requestInfo.url,
        type: requestInfo.type,
        requestContentType: requestInfo.contentType,
        acceptContentType: requestInfo.dataType,
        param: requestInfo.data,
        crossDomain: requestInfo.crossDomain,
        responseHeaders: xhr.getAllResponseHeaders ? xhr.getAllResponseHeaders() : '',
        responseText: xhr.responseText,
        responseStatus: xhr.status
      });
    };
  }

  onError(message, file, row, col) {
    if (window.CONFIG.debug) {
      return false;
    }
    this.uploadExceptionMsg(message, file, row, col);
    return true;
  }

  uploadExecptionMsg(message, file, row, col) {
    if (window.CONFIG.debug) {
      return;
    }
    let img = new Image();
    img.onload = () => {
      img = null;
    };

    img.onerror = () => {
      img = null;
    };

    img.src = window.CONFIG.exceptionServer +
        '?url=' + encodeURIComponent(location.href) +
        '&time=' + Date.now() +
        '&message=' + encodeURIComponent(message) +
        '&file=' + (file ? encodeURIComponent(file) : '') +
        '&row=' + (row || '') +
        '&col=' + (col || '') +
        '&os=' + encodeURIComponent(JSON.stringify($.os)) +
        '&browser=' + encodeURIComponent(JSON.stringify($.browser));
  }

  /**
   * 异常响应上报
   * 主要是model抛出，所以存在Zepto环境
   * @param obj
   */
  uploadExceptionResponse(obj) {
    if (window.CONFIG.debug) {
      return;
    }

    obj.url = location.href;
    obj.time = Date.now();
    obj.os = $.os;
    obj.browser = $.browser;
    $.post(window.CONFIG.exceptionServer, obj);
  }

  /**
   * 自定义异常类型
   * @param value
   * @param message
   * @constructor
   */
  Exception(value, message) {
    this.value = value;
    this.message = message;
    this.toString = function () {
      return String(message);
    };
  }

    // if (xhr.status === 400) {
    // } else if (xhr.status === 500) {
    // } else if (xhr.status === 404) {
    // }
};

window.Exception = new Exception();



// WEBPACK FOOTER //
// ./src/core/exception.js